import posthog from "posthog-js";

import { createTrackEvent, createTrackEvents } from "./track-event";

export { AnalyticsEvent, AnalyticsProperty, ErrorSurface } from "./constants";
export type {
  AnalyticsEventName,
  AnalyticsPropertyName,
  ErrorSurfaceName,
} from "./constants";
export { reportUserFacingError } from "./report-error";
export type { ReportUserFacingErrorOptions } from "./report-error";
export { createTrackEvent, createTrackEvents } from "./track-event";
export type { AnalyticsClient, CreateAnalyticsConfig } from "./track-event";

export const trackEvents = createTrackEvents({ client: posthog });
export const trackEvent = createTrackEvent({ client: posthog });
